module.exports = __webpack_public_path__ + "img/angelika.8e21fd12.png";